// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__26cZJ","expandIcon":"AccordionButton_expandIcon__37ZYU","expanded":"AccordionButton_expanded__2KvgF"};